import React from 'react';
import styled from 'styled-components';

interface AnalyticsFeedbackSliderProps {
  risk: number;
}

const AnalyticsFeedbackSlider: React.FC<AnalyticsFeedbackSliderProps> = ({ risk }) => {
  const clampedRisk = Math.max(0, Math.min(risk, 100));
  const flippedPosition = 100 - clampedRisk;

  return (
    <SliderContainer>
      <Scale>
        <Label align="left">Very Negative</Label>
        <Label align="center">Neutral</Label>
        <Label align="right">Very Positive</Label>
      </Scale>
      <Bar>
        <Circle style={{ left: `${flippedPosition}%` }} />
      </Bar>
    </SliderContainer>
  );
};

export default AnalyticsFeedbackSlider;

// Styled Components

const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 0;
  width: 100%;
`;

const Scale = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-family: 'Poppins', sans-serif;
  font-size: 10px;
  color: #7e7e7e;
  margin-bottom: 5px;
  padding: 0 5px;
`;

const Label = styled.div<{ align: 'left' | 'center' | 'right' }>`
  width: 33%;
  text-align: ${props => props.align};
  font-weight: 500;
  color: #414141;
`;

const Bar = styled.div`
  position: relative;
  width: 100%;
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(
    to right,
    rgba(255, 50, 90, 0.8) 0%,
    rgba(255, 50, 90, 0.4) 20%,
    rgba(255, 216, 111, 1) 40%,
    rgba(129, 199, 132, 0.5) 60%,
    rgba(129, 199, 132, 1) 80%,
    rgba(129, 199, 132, 1) 100%
  );
`;

const Circle = styled.div`
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  background: white;
  border: 2px solid #555;
  border-radius: 50%;
  z-index: 0;
`;
